import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="375"
    height="64"
    fill="none"
    viewBox="0 0 375 64"
  >
    <text
      fill="#fff"
      fillOpacity="0.5"
      style={{ whiteSpace: 'pre' }}
      fontSize="32"
      fontWeight="bold"
      letterSpacing="-1.28"
    >
      <tspan x="119.292" y="42.48">
        Podcasts
      </tspan>
    </text>
    <text
      fill="#fff"
      style={{ whiteSpace: 'pre' }}
      fontSize="32"
      fontWeight="bold"
      letterSpacing="-1.28"
    >
      <tspan x="13.248" y="42.48">
        Music
      </tspan>
    </text>
  </svg>
);
